/** Chuỗi của "Tính năng của tiệm" (ADR-074, KH-GĐ2 4.1). Tiếng Việt có dấu, câu ngắn. */
import type { TinhNang } from '@sapa/shared'

export const TN = {
  tab: 'Tính năng của tiệm',
  tieuDe: 'Tính năng của tiệm',
  giaiThich:
    'Tắt những gì tiệm không dùng để màn hình gọn hơn. Dữ liệu cũ vẫn giữ nguyên, bật lại là thấy.',
  luonCo: 'Luôn có: lịch hẹn, khách, tính tiền, chăm khách.',
  daBat: (ten: string) => `Đã bật ${ten.toLowerCase()}.`,
  daTat: (ten: string) => `Đã tắt ${ten.toLowerCase()}.`,
} as const

/** Tên + một câu giải thích cho mỗi tính năng đã có công tắc. */
export const MO_TA_TINH_NANG: Partial<Record<TinhNang, { ten: string; cau: string }>> = {
  'hoa-hong': { ten: 'Hoa hồng cho thợ', cau: 'Tự tính tiền công của thợ theo từng dịch vụ.' },
  'goi-vi': {
    ten: 'Gói và ví trả trước',
    cau: 'Bán gói nhiều buổi, khách nạp tiền trước rồi trừ dần.',
  },
  diem: { ten: 'Điểm thưởng', cau: 'Khách tích điểm khi trả tiền, lần sau đổi điểm để giảm giá.' },
  kho: { ten: 'Sản phẩm và kho', cau: 'Bán lẻ sản phẩm, biết hàng nào sắp hết.' },
  'chi-nhanh': { ten: 'Nhiều chi nhánh', cau: 'Tiệm có từ hai chỗ trở lên.' },
  'phan-quyen': {
    ten: 'Phân quyền chi tiết',
    cau: 'Thêm vai Quản lý và Lễ tân. Tắt thì chỉ có Chủ tiệm và Thợ.',
  },
  'tien-bo': {
    ten: 'Tiền bo cho thợ',
    cau: 'Ghi tiền khách bo, biết tiệm còn phải trả lại thợ bao nhiêu.',
  },
  'khoan-chi': {
    ten: 'Khoản chi và tiền lời',
    cau: 'Ghi tiền chi ra, cuối tháng biết tiệm lời bao nhiêu.',
  },
  'uu-dai': {
    ten: 'Ưu đãi khách mới',
    cau: 'Khách mới quét mã QR là nhận giảm giá lần đầu, số của khách vào sổ của tiệm.',
  },
  'dem-ket': {
    ten: 'Đếm két cuối ngày',
    cau: 'Cuối ngày đếm tiền mặt, biết ngay két thiếu hay đủ.',
  },
}
